import config from "config";

const LOCAL_STORAGE_KEY = "baseUrlConfig"

const DEFAULT_URL = config.BASE_URL;
const isDevEnv = (process.env.REACT_APP_IS_DEV_ENV === "true");

const URLS = [
    { name: "server", url: config.BASE_URL }
]

let BASE_URL = DEFAULT_URL;

if (isDevEnv) {
    const url = localStorage.getItem(LOCAL_STORAGE_KEY);
    BASE_URL = url || DEFAULT_URL;
}

function setUrl(url) {
    if (!isDevEnv) return;
    localStorage.setItem(LOCAL_STORAGE_KEY, url);
    BASE_URL = url;
    window.location.reload();
}

export { BASE_URL, URLS, isDevEnv, setUrl };
